import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as fromConfig from '../toastr/toastr.config';

@Injectable({
  providedIn: 'root'
})
export class AppToastrService {

  constructor(private toastr: ToastrService) { }

  /**
   * @param  string message
   * @param  {} null
   * @param  {} fromConfig.successConfigObj
   * @return {} show sucess toastr
   */

  success(message) {
    this.toastr.success(message, null, fromConfig.successConfigObj);
  }
  /**
   * @param  {} message
   * @param  {} {this.toastr.error(message
   * @param  {} null
   * @param  {} fromConfig.errorConfigObj
   */
  error(message) {
    this.toastr.error(message, null, fromConfig.errorConfigObj);
  }
  /**
   * @param  {} message
   * @param  {} {this.toastr.info(message
   * @param  {} null
   * @param  {} fromConfig.infoConfigObj
   */
  info(message) {
    this.toastr.info(message, null, fromConfig.infoConfigObj)
  }
  /**
   * @param  {} {this.toastr.clear}
   */
  dismissToastr() {
    this.toastr.clear();
  }
}
